import Router from "next/router";

import PageAlign from "@component/dashboard/offer/page_align";
import { PageRegistration } from "@component/flows/hooks/usePageFlow";
import StreamlinedHeader from "@component/onboarding/streamlined_header";
import { track } from "@util/analytics";

import styles from "./reverification_failed.module.scss";

interface ReverificationFailedPageProps extends PageRegistration {}

export default function ReverificationFailedPage({
  configFlow,
  Button,
}: ReverificationFailedPageProps) {
  configFlow
    .button(
      <Button
        onClick={() => {
          track.tap("Identity Reverification - Back Home Button");
          Router.replace("/dashboard");
        }}
        variant="black"
      >
        Back to Home
      </Button>
    )
    .bottom(<p className="center-child">Contact Support: 1 (844) 741-9271</p>);

  return (
    <PageAlign scroll>
      <div>
        <StreamlinedHeader displayCloseButton />
        <div className={`mt-4 color:error ${styles.warning}`}>
          <div></div>
        </div>
        <header className="text:heading-3 mt-4 mb-2">
          We couldn’t verify your identity
        </header>
        <div className="text:regular">
          Based on your personal information, we could not verify you’re you.
        </div>
      </div>
    </PageAlign>
  );
}
